import { mapKeysToCamelCase } from '@skytech/utils'

import { get, post } from '@/util/auth'

import {
  API_PATH_SUB_SERVICES,
  API_PATH_SUB_SERVICES_ADD_SERVICE,
  API_PATH_SUB_SERVICES_CANCEL_ORDER,
} from './apiRoutes'

type SubscriptionServiceOriginal = {
  id: number
  customer_head_id: number
  customer_id: number | null
  price: number
  name: string
  billing_cycle: number
  is_active: number
  is_exclusive: boolean
  is_sim_card_product: boolean
  api_supplier_service_type: string | null
  api_supplier_carrier_id: number | null
  api_supplier_service_id: number | null
  api_supplier_service_description: string | null
  api_supplier_service_original_name: string | null
  api_supplier_service_original_price: string | null
  is_default_subscription_service: number
  api_supplier_service_original_discount: string | null
  created: null
  subscription_service_guid: string
  status: number
  order_id: number
  comment: string | null
  currency: string
  changed: number
}

export const subscriptionServicesResources = {
  getList: async () => {
    const subscriptionServicesList = await get<SubscriptionServiceOriginal[]>(API_PATH_SUB_SERVICES)
    const parsedData = mapKeysToCamelCase(subscriptionServicesList)
    return parsedData
  },

  // Mutations
  addSub: async ({
    serviceId,
    ...payload
  }: {
    serviceId: number
    isEsim: boolean
    address?: string
    city?: string
    zip?: string
    simCardNo?: string
    eid?: string
    carrierId?: string
  }) =>
    post(API_PATH_SUB_SERVICES_ADD_SERVICE.replace(':serviceId', String(serviceId)), {
      // The endpoint may receive comment but this is not used on the fe
      comment: null,
      ...payload,
    }),
  cancelOrder: async ({ orderId }: { orderId: number }) =>
    post(API_PATH_SUB_SERVICES_CANCEL_ORDER.replace(':orderId', String(orderId)), {
      // The endpoint may receive comment but this is not used on the fe
      comment: null,
    }),
}

export type SubscriptionService = Awaited<
  ReturnType<typeof subscriptionServicesResources.getList>
>[number]
